/**
 * Enum defining user capabilities.
 */
export enum UserCapability {
  EDIT_ADMIN = "EDIT_ADMIN",
  EDIT_USER = "EDIT_USER",
  EDIT_VALIDATION = "EDIT_VALIDATION",
  SEE_ALL_SETTINGS = "SEE_ALL_SETTINGS",

  BASIC_LICENCE = "BASIC_LICENCE",
  DAMAGE_ASSESSMENT_AND_LEAK_DETECTION = "DAMAGE_ASSESSMENT_AND_LEAK_DETECTION",
  DRYING_AND_REPAIR = "DRYING_AND_REPAIR",
  OFFICE = "OFFICE",
  PROJECT_MANAGEMENT = "PROJECT_MANAGEMENT",

  SEE_ALL_PROJECTS = "SEE_ALL_PROJECTS",
  CREATE_PROJECT = "CREATE_PROJECT",
  DELETE_PROJECT = "DELETE_PROJECT",
  REOPEN_COMPLETED_PHASES = "REOPEN_COMPLETED_PHASES",
  EDIT_PROJECT = "EDIT_PROJECT",

  ASSIGN_PROJECT_TO_SELF = "ASSIGN_PROJECT_TO_SELF",
  ASSIGN_PROJECT_TO_OTHERS = "ASSIGN_PROJECT_TO_OTHERS",
  PROJECT_SUPERVISION = "PROJECT_SUPERVISION",

  EDIT_DEVICE_SETTINGS = "EDIT_DEVICE_SETTINGS",
  IMPORT_DEVICES = "IMPORT_DEVICES",
  EDIT_DEVICES = "EDIT_DEVICES",

  LEAK_DETECTION = "LEAK_DETECTION",
  DAMAGE_ASSESSMENT_LARGE = "DAMAGE_ASSESSMENT_LARGE",
  DRYING = "DRYING",
  REPAIR = "REPAIR",
  HAS_VEHICLE = "HAS_VEHICLE",

  // Only visible to client with administration capabilities
  CLIENT_ADMINISTRATION = "CLIENT_ADMINISTRATION",
  DEVICE_ADMINISTRATION = "DEVICE_ADMINISTRATION",
  SETTINGS_ADMINISTRATION = "SETTINGS_ADMINISTRATION",

  //USER_ADMINISTRATION = "USER_ADMINISTRATION",
  //LICENCE_ADMINISTRATION = "LICENCE_ADMINISTRATION",

  // Only visible to IRES users, for roles inside the IRES admin portal
  RATE_DRYINGS = "RATE_DRYINGS",
  MANAGE_PRODUCTION = "MANAGE_PRODUCTION",
  MANAGE_CLIENTS = "MANAGE_CLIENTS",
}

/**
 * User capabilities belonging to the IRES admin portal.
 *
 * These are hidden from ordinary clients' role settings editor, since the portal they apply to is
 * reachable only by clients listed in `administration/adminConfig.officeAdminClientIds`. Gated by
 * `configureAdminPortalCapabilitiesAccess()`; further areas migrated out of the IRES Admin Android
 * app should add their capabilities here rather than introducing another group.
 * @type {UserCapability[]}
 */
export const ADMIN_PORTAL_USER_CAPABILITIES = [
  UserCapability.RATE_DRYINGS,
  UserCapability.MANAGE_PRODUCTION,
  UserCapability.MANAGE_CLIENTS,
];

/**
 * Array containing user capabilities that are always granted to admin users.
 * @type {UserCapability[]}
 */
export const ADMINISTRATION_USER_CAPABILITIES = [
  UserCapability.CLIENT_ADMINISTRATION,
  UserCapability.DEVICE_ADMINISTRATION,
  UserCapability.SETTINGS_ADMINISTRATION,

  //UserCapability.USER_ADMINISTRATION,
  //UserCapability.LICENCE_ADMINISTRATION,
];

/**
 * Function to check if admin users always have a specific capability.
 * @param capability - The user capability to check.
 * @returns {boolean} - True if admin users always have the capability, otherwise false.
 */
export function doesAdminAlwaysHaveCapability(capability: UserCapability) {
  switch (capability) {
    case UserCapability.EDIT_ADMIN:
    case UserCapability.EDIT_USER:
    case UserCapability.EDIT_VALIDATION:
    case UserCapability.SEE_ALL_PROJECTS:
    case UserCapability.DELETE_PROJECT:
    case UserCapability.REOPEN_COMPLETED_PHASES:
    case UserCapability.EDIT_PROJECT:
    case UserCapability.IMPORT_DEVICES:
    case UserCapability.EDIT_DEVICES:
      return true;
  }

  return false;
}

